import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { invokeMqq, MqqNamespace } from "../data-source/mqq";
/**
 * 桌面端提供的将绝对路径转换为fileURL的方法
 * @description 会将/path/to/file转换为file:///path/to/file
 */
export var joinPathToFileUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(paths) {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return invokeMqq({
            namespace: MqqNamespace.Docx,
            methodName: 'pathToFileURL',
            data: {
              path: paths
            }
          });
        case 2:
          data = _context.sent;
          console.log(data, '@@@data');
          return _context.abrupt("return", data.url);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function joinPathToFileUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=path-to-file-url.js.map